import JsonSafeInput from './JsonSafeInput';

const jsonSafe = {
  name: 'JSON Safe',
  Input: JsonSafeInput,
  content: {},
  format: variable => {
    return `${variable}|json_safe`;
  },
  valid: () => true
};

export default jsonSafe;
